module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.salons) ? _c('div', {
    staticClass: "tabs-stocks panel panel-default"
  }, [_c('form', {
    staticClass: "form-stock",
    attrs: {
      "role": "form",
      "action": ("/stocks/" + _vm.salon_id),
      "method": "POST"
    }
  }, [_c('div', {
    staticClass: "stocks-head"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.role_supervisor == 0) ? _c('h2', [_vm._v("Выберите автосалон")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Название автосалона ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salon_id),
      expression: "salon_id"
    }],
    staticClass: "salon_id form-control",
    attrs: {
      "disabled": _vm.role_supervisor != 0 ? true : false,
      "name": "salon_id"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.salon_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.salonCheck]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Выберите салон")]), _vm._v(" "), _vm._l((_vm.salons), function(salon) {
    return _c('option', {
      domProps: {
        "value": ("" + (salon.id)),
        "selected": salon.id == _vm.role_supervisor ? true : false
      }
    }, [_vm._v(_vm._s(salon.name))])
  })], 2)])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activated == 0
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 0;
        _vm.textarea = 0
      }
    }
  }, [_vm._v("\n                    При запуске\n                ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activated == 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 1;
        _vm.textarea = 1
      }
    }
  }, [_vm._v("\n                    После анкеты\n                ")])])]), _vm._v(" "), _c('input', {
    attrs: {
      "name": "_method",
      "value": "PUT",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "_token",
      "type": "hidden"
    },
    domProps: {
      "value": ("" + _vm.csrf_token)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 0),
      expression: "activated == 0"
    }],
    staticClass: "panel panel-default",
    attrs: {
      "activated": "0"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.before),
      expression: "before"
    }],
    class: {
      active: _vm.textarea == 0
    },
    attrs: {
      "name": "before"
    },
    domProps: {
      "value": (_vm.before)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.before = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.before))]), _vm._v(" "), _c('div', [_vm._v("*Не более 1000 символов")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Сохранить")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 1),
      expression: "activated == 1"
    }],
    staticClass: "panel panel-default",
    attrs: {
      "activated": "1"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.after),
      expression: "after"
    }],
    class: {
      active: _vm.textarea == 1
    },
    attrs: {
      "name": "after"
    },
    domProps: {
      "value": (_vm.after)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.after = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.after))]), _vm._v(" "), _c('div', [_vm._v("*Не более 1000 символов")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Сохранить")])])])]) : _c('h3', [_vm._v("Загрузка салонов ...")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3bcaf946", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bcaf946"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsStocks.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3bcaf946"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsStocks.vue
// module chunks = 0